import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { initAnalytics } from "@/lib/tracking";

export function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!window.localStorage.getItem("mbc-consent")) {
      const t = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(t);
    }
    initAnalytics();
  }, []);

  const choose = (value) => {
    window.localStorage.setItem("mbc-consent", value);
    if (value === "accepted") initAnalytics();
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 24 }}
          transition={{ duration: 0.4 }}
          className="fixed bottom-20 md:bottom-6 left-4 right-4 sm:left-auto sm:right-6 sm:max-w-sm z-50 rounded-2xl border border-warm-200 bg-white p-5 shadow-2xl"
          role="dialog"
          aria-label="Cookie consent"
          data-testid="cookie-banner"
        >
          <p className="text-sm font-semibold text-slate-900 mb-1">
            Cookies on this site
          </p>
          <p className="text-xs leading-relaxed text-slate-600 mb-4">
            We use essential cookies to make the site work. With your consent
            we'd also like to use analytics cookies to improve it. See our{" "}
            <Link to="/privacy-policy" className="underline text-navy-800">
              Privacy Policy
            </Link>
            .
          </p>
          <div className="flex gap-2">
            <button
              type="button"
              data-testid="cookie-accept-btn"
              onClick={() => choose("accepted")}
              className="flex-1 rounded-full bg-navy-900 py-2.5 text-xs font-semibold text-white hover:bg-navy-800 transition-colors"
            >
              Accept analytics
            </button>
            <button
              type="button"
              data-testid="cookie-decline-btn"
              onClick={() => choose("declined")}
              className="flex-1 rounded-full border border-warm-300 py-2.5 text-xs font-semibold text-slate-700 hover:bg-warm-100 transition-colors"
            >
              Essential only
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
